export default function ObjectBuilder<T extends Record<string, any>>(
    initialState: T,
    response: Partial<T>
  ): T {
    return Object.keys(initialState).reduce((mappedObj, key) => {
      (mappedObj as Record<string, any>)[key] = response[key] !== undefined ? response[key] : initialState[key];
      return mappedObj;
    }, { ...initialState });
  }
  